<template>
  <main class="min-h-screen bg-primary-dark">
    <TheNavigation />
    <HeroSection />
    <div class="bg-white rounded-[40px]">
      <ClientsTicker />
      <Features />
      <HowItWorks />
      <Testimonials />
      <FAQ />
    </div>
    <TheFooter />
    <ScrollToTopButton />
  </main>
</template>

<script>
import { isAuthenticated } from "@/services/token";
import TheNavigation from "@/components/TheNavigation.vue";
import HeroSection from "@/components/homepage/HeroSection.vue";
import ClientsTicker from "@/components/homepage/ClientsTicker.vue";
import Features from "@/components/homepage/Features.vue";
import HowItWorks from "@/components/homepage/HowItWorks.vue";
import Testimonials from "@/components/homepage/Testimonials.vue";
import TheFooter from "@/components/homepage/TheFooter.vue";
import FAQ from "@/components/homepage/FAQ.vue";
import ScrollToTopButton from "@/components/ui/ScrollToTopButton.vue";

export default {
  name: "HomePage",
  components: {
    TheNavigation,
    FAQ,
    TheFooter,
    HeroSection,
    Testimonials,
    ClientsTicker,
    Features,
    HowItWorks,
    ScrollToTopButton,
  },
  data() {
    return {
      isAuthenticated: false,
    };
  },
  created() {
    this.checkAuthentication();
  },
  methods: {
    checkAuthentication() {
      this.isAuthenticated = isAuthenticated();
    },
  },
};
</script>
